import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import { getUserDetails } from "../../services/apiProfile";
import "../../assets/css/style_new.css";
import coverimg from "../../assets/img/profile/default-cover.svg"
import profileimg from "../../assets/img/profile/profile-img.svg"
import eye from "../../assets/img/profile/eye.svg"
import eye2 from "../../assets/img/profile/eyesingle.svg"
//import edit from "../../assets/img/profile/edit.svg"
import community1 from "../../assets/img/profile/community1.svg"
import plus from "../../assets/img/profile/pluswhite.svg"
import mapin from "../../assets/img/profile/map-pin.svg"
import search from "../../assets/img/profile/search.svg"
import event from "../../assets/img/profile/event-img.png"
import Favoritesimg from "../../assets/img/fovr-img.svg"
import videoimg from "../../assets/img/video-img.svg"
import playimg from "../../assets/img/play-circles.svg"
import leftarrow from "../../assets/img/left-sider.svg"
import rightarrow from "../../assets/img/right-sider.svg"
import dele from "../../assets/img/slash.svg";
import edit from "../../assets/img/edit-3.svg";
import cal from "../../assets/img/calendar.svg"
import checkb from "../../assets/img/Checkbox-base.svg"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import quest from "../../assets/img/profile/questions.svg"
import editp from "../../assets/img/profile/edit-4.svg"
import ProfileBio from "./ProfileBio";
import ProfileCommunity from "./ProfileCommunity";
import Spinner from "../../commonComponents/Spinner";
import AttendPopUp from "../UpcomingEvents/AttendPopUp";
import { deleteEvent, getAllEventPlaces, getCommunityEvents } from "../../services/apiEvent";
import moment from "moment-timezone";
import AttendingEvents from "./AttendingEvents";
import eventimg from "../../assets/img/event/event-img.png"
import attendimg from "../../assets/img/event/attendimg.png"
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import "../../assets/css/save.css";

const UpcomingEvents = (props) => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData'));
  const communityDetails = JSON.parse(localStorage.getItem('communityData'));
  const [isAttend, setIsAttend] = useState(false);
  const [isAttendStatus, setIsAttendStatus] = useState(false);
  const [eventId, setEventId] = useState('');
  const [eventType, setEventType] = useState('');
  const [eventTitle, setEventTitle] = useState('');
  const [localAddress, setlocalAddress] = useState('');
  const [filterLocation, setFilterLocation] = useState('');
  const [eventListArr, setEventListArr] = useState([]);
  const [attendingEventListArr, setAttendingEventListArr] = useState([]);
  const [locationArr, setLocationArr] = useState([]);
  const [isLocation, setIsLocation] = useState(false);
  const [offset, setOffset] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [attendMode, setAttendMode] = useState("");
  const sliderRef = useRef(null);

  const handleAttendClose = () => setIsAttend(false);

  useEffect(() => {
    listcommunityEvents(0, false);
  }, []);

  const listcommunityEvents = async (newOffset = 0, isLoadMore = false) => {
    if (isFetching) return;

    setIsFetching(true);

    const formData = {
      communityid: props.type === "events" ? communityDetails?._id : "",
      userid: props.type === "events" ? "" : userData._id,
      searchkey: eventTitle,
      filterlocation: filterLocation,
      filtertype: eventType,
      offset: newOffset,
      limit: 5,
    };
    
    try {
      let listCommunityEvent = await getCommunityEvents(formData);
      const newEvents = listCommunityEvent.events || [];
      const attendEvents = listCommunityEvent.attendingEvents || [];

      setAttendingEventListArr(attendEvents)

      if (isLoadMore) {
        setEventListArr((prev) => [...prev, ...newEvents]);
      } else {
        setEventListArr(newEvents);
      }

      setOffset(newOffset + newEvents.length); // ✅ use newOffset, not prevOffset

      if (newEvents.length < 5) { // ✅ match limit
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error loading events:", error);
    } finally {
      setIsFetching(false);
    }
  };
  const listcommunityEventsAttend = () => {
    setOffset(0);         // ✅ Reset offset
    setHasMore(true);
    listcommunityEvents(0, false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= fullHeight - 100 && hasMore && !isFetching) {
        listcommunityEvents(offset, true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, isFetching]);

  useEffect(() => {
    setOffset(0);
    setHasMore(true);
    listcommunityEvents(0, false);
  }, [eventTitle, eventType, filterLocation]);
  useEffect(() => {
    if (localAddress !== '') {
      getLocation(localAddress)
    }
    else {
      setLocationArr([])
      listcommunityEvents(0, false)
    }
  }, [localAddress])
  const getLocation = async (address) => {
    const formData = {
      searchkey: address,
    }
    let localities = await getAllEventPlaces(formData);
    setLocationArr(localities.locations);

  }
  

  


  const formatGoogleCalendarUrl = (event) => {
    const {
      eventStartDate,
      eventStartTime,
      eventEndDate,
      eventEndTime,
      timezone,
      eventTitle,
      eventShortDescription,
      location = '',
    } = event;

    const startUtc = formatDateUTC(eventStartDate, eventStartTime, timezone);
    const endUtc = formatDateUTC(eventEndDate, eventEndTime, timezone);

    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: eventTitle,
      dates: `${startUtc}/${endUtc}`,
      details: eventShortDescription,
      location,
      ctz: timezone,   // show event in user’s zone
      sf: 'true',
      output: 'xml',
    });

    return `https://www.google.com/calendar/render?${params.toString()}`;
  };
  const formatDateUTC = (isoDate, timeStr, tz) => {
    const datePart = isoDate.split('T')[0];           // "2025-07-26"
    const pattern = /[AP]M$/i.test(timeStr)
      ? 'YYYY-MM-DD hh:mm A'
      : 'YYYY-MM-DD HH:mm';

    const localDT = moment.tz(`${datePart} ${timeStr}`, pattern, tz);
    return localDT.utc().format('YYYYMMDDTHHmmss') + 'Z';
  };




  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -sliderRef.current.offsetWidth / 3,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: sliderRef.current.offsetWidth / 3,
        behavior: 'smooth',
      });
    }
  };


  const cancelEvent = async (id) => {

    const formData = {
      eventid: id
    };
    
    try {
      let cancelEvent = await deleteEvent(formData);
      

      listcommunityEvents(0, false);

    } catch (error) {
      console.error("Error loading events:", error);
    } finally {
      setIsFetching(false);
    }
  };
  const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");


  const handleImageClick = (first, last, id, type) => {
    if (type === "individual") {
       const userName = `${slugify(first)}-${slugify(last)}`;
      if (userData._id === id)
        navigate('/profile');
      else
        navigate(`/profile/${userName}`, { state: { userId: id } })
    } else {
      if (userData._id === id)
        navigate('/organization');
      else
        navigate(`/organization/${slugify(first)}`, { state: { userId: id } })
    }

  };

  return (

    <div>
      <div className="eventfilter-sec mt-3">
        <div className="searchevents">
          <div className="form-group">
            <img src={search} alt="test" className="input placeholder" />
            <input type="form-control" className="form-control" placeholder="Search Events"
              onChange={(e) => { setEventTitle(e.target.value) }} value={eventTitle}></input>
          </div>
        </div>

        <div className="locationevent">
          <div className="form-group">
            <select className="form-select event-types" onChange={(e) => { setEventType(e.target.value) }} value={eventType}>
              <option value="">Event type</option>
              <option value="yes">Virtual</option>
              <option value="no">In Person</option>
              <option value="hybrid">Hybrid</option>
            </select>
          </div>
        </div>


        <div className="locationevent">
          <div className="form-group">
            <img src={mapin} alt="test" className="placeholcder" />
            <input type="text" class=" form-control " placeholder="Search here"
              id="exampleFormControlInput1"
              value={localAddress}
              onChange={(e) => {
                e.preventDefault();
                setlocalAddress(e.target.value);
                setFilterLocation("");
                setIsLocation(true);
              }}
              autoComplete="off" />
            {locationArr.length > 0 && isLocation && (
              <ul className="drop-div-join list-group mt-1 responsive-dropdown">
                {locationArr.map((item, index) => (
                  <li key={index} className="list-group-item d-flex align-items-center">
                    <input
                      type="radio"
                      name="communityOption"
                      id={`option-${index}`}
                      value={item}
                      checked={localAddress === item}
                      onChange={(e) => {
                        e.preventDefault();
                        setFilterLocation(item)
                        setlocalAddress(item);
                        setIsLocation(false);
                      }}
                      className="form-check-input me-2"
                    />
                    <label htmlFor={`option-${index}`} className="form-check-label w-100 mb-0">
                      {item}
                    </label>
                  </li>
                ))}
              </ul>
            )}

          </div>
        </div>

        <button className="main-btn" onClick={() => navigate(`/event/create-event`, { state: { Page: props.type, Status: "create" } })}><img src={plus} alt="test" className="community_thumb" /> Create Event</button>
      </div>

      {props.type === "events" ? null :

        <div >
          <h5 className='mt-4 upcommingevents' >Upcomming Events</h5>
          <div className="position-relative mt-3">

            <button
              className={attendingEventListArr?.length > 3 ? "arrow left-arrow position-absolute top-50 start-0 translate-middle-y z-3" : "d-none"}
              onClick={scrollLeft}
            >
              ‹
              {/* <img src={leftarrow} alt="Podcast thumbnail" className="" /> */}
            </button>
            <div ref={sliderRef} className="d-flex overflow-auto slider-section  gap-0" style={{ scrollBehavior: 'smooth', width: '100%' }}>

              {attendingEventListArr.map((eventList, index) => {
                 const attendeeNo = eventList.attendees.length > 4
            ? eventList.attendees.length - 4
            : "";

                return (
                  <div className='event-itm d-flex position-relative slider-itm col-12 col-sm-6 col-md-4 mb-4 border-0'>
                    <div className='event-image'>
                      <img src={eventList.eventImage ? API.uploadFilePath + eventList.eventImage : profileimg} alt="test" className="event-thumbnail" />
                    </div>
                    <div className='event-details'>
                      <div className='event-time'>
                        <p>
                          {eventList.eventStartDate && eventList.eventStartTime ? (
                            `${moment(`${eventList.eventStartDate.split("T")[0]} ${eventList.eventStartTime}`, "YYYY-MM-DD hh:mm A")
                              .format("MM/DD/YYYY, dddd [at] hh:mm A")} ${eventList.timezone ? ` ${eventList.timezone}` : ''} |`
                          ) : ''}
                          {eventList.location ? eventList.location : null}
                        </p>
                      </div>
                      <h2>{eventList.eventTitle}</h2>
                      <p className='event-description' >{eventList.eventShortDescription}</p>
                      <div className='eventpeoples d-flex align-items-center' >
                        <div className='people-list'>
                          {eventList.attendees.slice(0, 4).map((atten, index) => {
                            const user = atten?.users?.[0];
                            const hasImage = user?.profileImage?.url;
                            const isPrivate = user?.profileSettings?.isPrivateProfile;
                            const imgSrc = hasImage && !isPrivate
                              ? API.uploadFilePath + user.profileImage.url
                              : profileimg;

                            return (
                              <img
                                key={index}
                                src={imgSrc}
                                alt="attendee"
                                className="community_thumb"
                                onError={(e) => { e.target.onerror = null; e.target.src = profileimg }}
                                onClick={() => {
                                  handleImageClick(user?.firstName, user?.lastName, user._id, user.userType);
                                }}
                              />
                            );
                          })}
                        </div>
                        {attendeeNo && <h6>{`${attendeeNo}+ Attending`}</h6>}
                      </div>
                      <div className='event-button-group d-flex'>
                        <button className='main-btn secondary' onClick={() => navigate('/event-details', { state: { eventId: eventList._id, attende: eventList?.attendees, attenNo: attendeeNo } })}><img src={eye2} alt="test" className="community_thumb" />View </button>
                        <button className='main-btn flex-fill' onClick={() => {
                        const calendarUrl = formatGoogleCalendarUrl(eventList);
                        window.open(calendarUrl, "_blank");
                      }} ><img src={cal} alt="test" className="community_thumb" />Add to calendar</button>
                      </div>
                    </div>
                  </div>
                )
              })}


            </div>
            <button
              className={attendingEventListArr?.length > 3 ? "arrow right-arrow position-absolute top-50 end-0 translate-middle-y z-3" : "d-none"}
              
              onClick={scrollRight}
            >
              ›
              {/* <img src={rightarrow} alt="Podcast thumbnail" className="" /> */}
            </button>
          </div>
        </div>}

      

      <div className="events-list event-details-wrapper">
        {eventListArr?.map((eventList, index) => {
          const isAttending = eventList.attendees.some(
            (attendee) => attendee.userId === userData._id
          );
          const attendeeNo = eventList.attendees.length > 4
            ? eventList.attendees.length - 4
            : "";

          return (
            <div className="event-itm d-flex position-relative">
              <div className="event-image">
                <img src={eventList.eventImage ? API.uploadFilePath + eventList.eventImage : profileimg} alt="test" className="event-thumbnail" />
              </div>
              <div className="event-details">
                <div className="event-time">
                  <p>

                    {eventList.eventStartDate && eventList.eventStartTime ? (
                      `${moment(`${eventList.eventStartDate.split("T")[0]} ${eventList.eventStartTime}`, "YYYY-MM-DD hh:mm A")
                        .format("MM/DD/YYYY, dddd [at] hh:mm A")} ${eventList.timezone ? ` ${eventList.timezone}` : ''} |`
                    ) : ''}
                    {eventList.location ? eventList.location : null}
                  </p>

                </div>
                <h2>{eventList.eventTitle}</h2>
                <p className="event-description">{eventList.eventShortDescription}</p>
                <div className="eventpeoples d-flex align-items-center">
                  <div className="people-list">
                    
                    {eventList.attendees.slice(0, 4).map((atten, index) => {
                      const user = atten?.users?.[0];
                      const hasImage = user?.profileImage?.url;
                      const isPrivate = user?.profileSettings?.isPrivateProfile;
                      const imgSrc = hasImage && !isPrivate
                        ? API.uploadFilePath + user.profileImage.url
                        : profileimg;

                      return (
                        <img
                          key={index}
                          src={imgSrc}
                          alt="attendee"
                          className="community_thumb"
                          onError={(e) => { e.target.onerror = null; e.target.src = profileimg }}
                          onClick={() => {
                            handleImageClick(user?.firstName, user?.lastName, user._id, user.userType);
                          }}
                        />
                      );
                    })}
                  </div>
                  {attendeeNo && <h6>{`${attendeeNo}+ Attending`}</h6>}
                </div>
                {!eventList.isActiveEvent ?
                  <p className="event-calcel mt-4">
                    Event Cancelled
                  </p> :
                  <div className="event-button-group d-flex">
                    <button className="main-btn secondary" onClick={() => navigate('/event-details', { state: { eventId: eventList._id, attende: eventList?.attendees, attenNo: attendeeNo } })}><img src={eye2} alt="test" className="community_thumb" />View Event Details </button>

                    {isAttending ? <>
                      <button className="main-btn" onClick={() => {
                        const calendarUrl = formatGoogleCalendarUrl(eventList);
                        window.open(calendarUrl, "_blank");
                      }}><img src={cal} alt="test" className="community_thumb" />Add event to calendar</button>
                      <button className="main-btn secondary attending" onClick={() => { setEventId(eventList._id); setIsAttend(true); setAttendMode("cancel"); }}>
                        <img src={checkb} alt="test" className="community_thumb" />Attending</button>
                    </> :
                      eventList.userId === userData._id ?
                        <>
                          {eventList.eventStatus === 2 && <button className="main-btn" onClick={() => {
                            const calendarUrl = formatGoogleCalendarUrl(eventList);
                            window.open(calendarUrl, "_blank");
                          }}><img src={cal} alt="test" className="community_thumb" />Add event to calendar</button>}
                          {eventList.eventStatus === 1 && <button className="main-btn " onClick={() => navigate(`/event/create-event`, { state: { eventId: eventList._id, Status: "edit" } })} >
                            <img src={editp} alt="test" className="community_thumb" />

                            Edit Draft</button>} </>
                        : eventList.userId !== userData._id ?
                          <button className="main-btn" onClick={() => { setEventId(eventList._id); setIsAttend(true); setAttendMode("attend"); }}><img src={plus} alt="test" className="community_thumb" />Attend</button> : null}
                  </div>}

              </div>
              {eventList.userId === userData._id && eventList.isActiveEvent && <div className="moreoption position-absolute" style={{ right: "0px" }}>


                <div class="dropdown">
                  <button className="more">&#x22EE;</button>
                  <div class="dropdown-content">
                   

                    <Link className="button delet" onClick={(e) => { e.preventDefault(); cancelEvent(eventList._id,) }} >
                      <i class="bi bi-x-circle-fill" style={{ color: "red" }}></i> &nbsp;&nbsp;Cancel</Link>
                  </div>

                </div>



              </div>}
            </div>
          )
        })}


      </div>
      {isAttend && <AttendPopUp isAttend={isAttend} handleClose={handleAttendClose} eventId={eventId} listEvent={listcommunityEventsAttend} mode={attendMode} />}
    </div>
  );

};
export default UpcomingEvents;
